import React, { useEffect, useState } from "react";
import { Alert, Button, Form, Modal } from "react-bootstrap";

import { adminMutation, errorMessage } from "./api";

export const REPAIR_CONFIRMATION = "REPAIR";
export const isRepairConfirmation = value => String(value || "").trim().toUpperCase() === REPAIR_CONFIRMATION;

export default function RepairSynchronizationModal({ show, allocationId, onCancel, onComplete }) {
  const [confirmation, setConfirmation] = useState("");
  const [reason, setReason] = useState("");
  const [failure, setFailure] = useState("");
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    if (!show) return;
    setConfirmation("");
    setReason("");
    setFailure("");
    setSaving(false);
  }, [show, allocationId]);

  const close = () => {
    if (!saving) onCancel();
  };

  const submit = async event => {
    event.preventDefault();
    if (!allocationId || !reason.trim() || !isRepairConfirmation(confirmation)) return;
    setSaving(true);
    setFailure("");
    try {
      const result = await adminMutation("post", "/synchronization/repair", {
        allocationId,
        confirmation: REPAIR_CONFIRMATION,
        reason: reason.trim(),
      });
      onComplete(result);
    } catch (error) {
      setFailure(errorMessage(error));
      setSaving(false);
    }
  };

  return <Modal show={show} onHide={close} centered backdrop={saving ? "static" : true} keyboard={!saving}>
    <Form onSubmit={submit}>
      <Modal.Header closeButton={!saving}>
        <Modal.Title>Repair synchronization?</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {failure && <Alert variant="danger">{failure}</Alert>}
        <Alert variant="warning">
          This republishes the authoritative license and entitlement state through the product lifecycle workflow.
        </Alert>
        <Form.Group className="mb-3" controlId="repair-synchronization-reason">
          <Form.Label>Reason for repair</Form.Label>
          <Form.Control
            as="textarea"
            rows={3}
            required
            maxLength={1000}
            value={reason}
            onChange={event => setReason(event.target.value)}
            disabled={saving}
          />
        </Form.Group>
        <Form.Group controlId="repair-synchronization-confirmation">
          <Form.Label>Type <strong>{REPAIR_CONFIRMATION}</strong> to confirm</Form.Label>
          <Form.Control
            value={confirmation}
            onChange={event => setConfirmation(event.target.value)}
            disabled={saving}
            autoComplete="off"
          />
        </Form.Group>
      </Modal.Body>
      <Modal.Footer>
        <Button type="button" variant="outline-secondary" onClick={close} disabled={saving}>Cancel</Button>
        <Button
          type="submit"
          variant="warning"
          disabled={saving || !reason.trim() || !isRepairConfirmation(confirmation)}
        >
          {saving ? "Starting repair…" : "Repair synchronization"}
        </Button>
      </Modal.Footer>
    </Form>
  </Modal>;
}
